import assert from "assert";
import { Boolean, Record } from "runtypes";
export const UpdateSharing = Record({
  sharing: Boolean
});
export const getWalkthroughDuration = (trace) => {
  const start = new Date(trace[0].timestamp);
  const end = new Date(trace[trace.length - 1].timestamp);
  const traceDuration = end.valueOf() - start.valueOf();
  assert(traceDuration > 0);
  return traceDuration / 1e3;
};
export * from "./collections";
export * from "./content";
export * from "./languages";
export * from "./lessonplan";
export * from "./mapping";
export * from "./metadata";
export * from "./progress";
export * from "./rating";
export * from "./watched";
//# sourceMappingURL=index.js.map
